import { render } from "./FileContentsIndex.vue?vue&type=template&id=4f961ffa&scoped=true&ts=true"
import script from "./FileContentsIndex.vue?vue&type=script&lang=ts"
export * from "./FileContentsIndex.vue?vue&type=script&lang=ts"

import "./FileContentsIndex.vue?vue&type=style&index=0&id=4f961ffa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f961ffa"]])

export default __exports__